import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, mergeProps as _mergeProps, withCtx as _withCtx, createBlock as _createBlock, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = ["href"]

import { ElButton } from 'element-plus';
import { ref, useAttrs } from 'vue';
import { sleep } from '@/js/lib/helper/sleep';


export default /*@__PURE__*/_defineComponent({
  ...{
  inheritAttrs: false,
},
  __name: 'IButton',
  props: {
    type: { default: '' },
    nativeType: { default: 'button' },
    size: { default: '' },
    href: { default: '' },
    flexible: { type: Boolean },
    center: { type: Boolean }
  },
  setup(__props: any, { expose: __expose }) {



const attrs = useAttrs();
const buttonEl = ref();
const isShowRipple = ref(false);
const showRipple = async () => {
  isShowRipple.value = true;
  await sleep(100);
  isShowRipple.value = false;
};

__expose({
  focus: async () => {
    await sleep(100);
    buttonEl.value.ref.focus();
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_ctx.$style.wrapper),
    onMousedown: showRipple
  }, [
    (_ctx.href)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          href: _ctx.href,
          class: _normalizeClass(['el-button', _ctx.type && `el-button--${_ctx.type}`, _ctx.size && `el-button--${_ctx.size}`, _ctx.$style.link, _ctx.flexible && _ctx.$style.flexible, _ctx.center && _ctx.$style.center])
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 10, _hoisted_1))
      : (_openBlock(), _createBlock(_unref(ElButton), _mergeProps({
          key: 1,
          ref_key: "buttonEl",
          ref: buttonEl,
          type: _ctx.type,
          "native-type": _ctx.nativeType,
          size: _ctx.size,
          class: [_ctx.flexible && _ctx.$style.flexible, _ctx.center && _ctx.$style.center]
        }, _unref(attrs)), {
          default: _withCtx(() => [
            _renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["type", "native-type", "size", "class"])),
    _cache[0] || (_cache[0] = _createTextVNode()),
    _createElementVNode("div", {
      class: _normalizeClass([_ctx.$style.ripple, isShowRipple.value && _ctx.$style.isShowRipple])
    }, null, 2)
  ], 34))
}
}

})